import { BaseTab } from '@hdms/shared/common-types';

export class Tab implements BaseTab {
  id: string;
  active?: boolean;
  contentReference?: string;
}
